import React, { Component } from "react";
import HeaderTwo from "../../components/HeaderTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import AboutUs from "../../components/AboutUs";
import IconBox from "../../components/IconBox";
import TabBox from "./../../components/TabBox";
import TestimonialSlider from "../../components/TestimonialSlider";
import FaqEvent from "../../components/FaqEvent";
import FooterTwo from "../../components/FooterTwo";
import { Styles } from "./styles/franchise";
import FranchiseBox from "../../components/Franchise";
import MeetTheTeamSlider from "../../components/MeetTheTeamSlider";

const MeetTheTeam = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper about-page">
        {/* Header 2 */}
        <HeaderTwo />

        {/* <BreadcrumbBox title="Services" /> */}
        {/* 
        <AboutUs />

        <IconBox /> */}

        {/* Tab Section */}
        {/* <FranchiseBox /> */}

        {/* Testimonial Slider */}
        <MeetTheTeamSlider />

        {/* Faq & Event Area */}
        {/* <FaqEvent /> */}

        {/* Footer 2 */}
        <div style={{marginTop:30}}>
          <FooterTwo />
        </div>
      </div>
    </Styles>
  );
};

export default MeetTheTeam;
